const CardHeader = ({ children }) => <div className="p-4 border-b">{children}</div>;

export default CardHeader